export enum GlobalCcctCombination {
  Tax = 2262,
  Contingency = 3071
}